import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const Text = styled.div`
    height: ${({ webHeight }) => (webHeight ? webHeight : '155px')};
    font: ${({ font }) => (font ? font : '16px Avenir Next World')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    color: ${({ color }) => (color ? color : '#000000')};
    letter-spacing: ${(props) =>
        props.letterSpacing ? props.letterSpacing : '-0.11px'};
    opacity: 1;
    padding-top: 12px;
    line-height: ${({ lineHeight }) => lineHeight};
    flex-grow: ${({ flexGrow }) => (flexGrow ? flexGrow : '0')};
    padding: ${({ textPadding }) => textPadding};
    ${media.mobileDevice` 
        height: ${({ height }) => (height ? height : '190px')};
        font: ${({ font }) => (font ? font : '15px Avenir Next World')};
        font-family:'AvenirNextWorld Regular';
     word-break: break-word;
    white-space: normal;
    
    `};
`;

export const SubText = styled(Text)`
    height: ${({ subTextHeight }) => (subTextHeight ? subTextHeight : '63px')};
    ${media.mobileDevice` 
        height:${(props) =>
            props.mbSubTextHeight ? props.mbSubTextHeight : '100%'} ;
    `};
`;

export const Div = styled.div`
    display: flex;
    justify-content: ${({ center, justifyContent }) =>
        justifyContent ? justifyContent : center ? 'center' : 'flex-end'};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    position: ${({ position }) => (position ? position : 'static')};
    flex-direction: ${({ showCancel }) => (showCancel ? 'row' : '')};
    -webkit-flex: ${({ webkitFlex }) => (webkitFlex ? webkitFlex : '')};
    flex-shrink: ${({ flexShink }) => (flexShink ? flexShink : '')};
    bottom: 0;
    ${media.mobileDevice` 
    margin-top: ${({ mobileMarginTop }) =>
        mobileMarginTop ? mobileMarginTop : ''};
    margin-bottom: ${({ mobileMarginBottom }) =>
        mobileMarginBottom ? mobileMarginBottom : ''};
    `};
`;

export const DesktopWrap = styled.div`
    display: flex;
    flex-direction: ${({ flexDirection }) =>
        flexDirection ? flexDirection : ''};
    align-items: ${({ alignItems }) => (alignItems ? alignItems : '')};
    justify-content: ${({ justifyContent }) => justifyContent};
    ${media.mobileDevice` 
        flex-wrap:wrap;
    `};
`;

export const DraftDiv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 420px;
    height: ${({ height }) => (height ? height : '115px')};
    ${media.mobileDevice`
         width:${({ mobileWidth }) => (mobileWidth ? mobileWidth : '310px')};
         height:${(props) =>
             props.mbDraftDivHeight
                 ? props.mbDraftDivHeight
                 : '100%'};                  
         `}
`;

export const MyProfileDiv = styled.div`
    width: 430px;
    height: 450px;
    ${media.mobileDevice`
         width:310px;
         height:440px;                
         `}
`;

export const ProductDelayDiv = styled.div`
    width: 430px;
    height: 200px;
    ${media.mobileDevice`
         width:310px;
         height:240px;                  
         `}
`;
export const RequestDeliveryDateNotificationDiv = styled.div`
    width: 430px;
    height: 200px;
    ${media.mobileDevice`
         width:${(props) => (props.mobileWidth ? props.mobileWidth : '310px')};
         height:${(props) =>
             props.mobileHeight ? props.mobileHeight : '240px'};         
         `}
`;
export const UnsavedChangesDiv = styled.div`
    width: ${(props) => (props.divWidth ? props.divWidth : '430px')};
    display: flex;
    flex-direction: column;
    height: ${({ divHeight }) => (divHeight ? divHeight : '63px')};
    ${media.mobileDevice`
         width:310px;
         height:${(props) =>
             props.mbDivHeight ? props.mbDivHeight : '160px'};                 
    `}
    @media screen and (max-device-width: 360px) {
        width: auto;
    }
`;

export const Subtitle = styled.div`
    font-family: 'AvenirNextWorld Regular';
    color: '#202124';
    font-size: 16px;
    margin-bottom: 10px;
`;

export const Title = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-top: 10px;
`;

export const ExpeditedDiv = styled.div`
    width: 420px;
    height: 50px;
    ${media.mobileDevice`
         width:310px;
         height:50px;                  
         `}
`;
export const AddedMoreThanTenItemsDiv = styled(ExpeditedDiv)``;
export const NonTissueSetSurgeryDiv = styled(ExpeditedDiv)``;

export const ItemNotAvailableDiv = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 420px;
    overflow-y: visible;
    height: ${({ height }) => (height ? height : '205px')};
    ${media.mobileDevice`
        width:310px;
        height: ${({ mbHeight }) => (mbHeight ? mbHeight : '210px')};
        min-height: 130px;
    `}
`;
export const ItemNotAllowedAsExtraDiv = styled(ItemNotAvailableDiv)``;

export const ShortText = styled(Text)`
    color: #130e4a;
    font-size: 17px;
    font-family: 'AvenirNextWorld Demi';
    padding-top: 0px;
    display: flex;
    justify-content: center;

    ${media.mobileDevice`
font-family:'AvenirNextWorld Demi';
display:flex;
justify-content:flex-start;           
         `}
`;
export const ExcludedItemsNotAddedDiv = styled.div`
    width: 420px;
    max-height: 550px;
    overflow-y: auto;
    ${media.mobileDevice`
         width:310px; 
         max-height:400px;
         overflow-y:auto;             
         `}
`;
export const ItemsText = styled.div`
    height: 30px;
    font-size: 16px;
    font-family: 'AvenirNextWorld Regular';
    color: #130e4a;
    letter-spacing: -0.11px;
    opacity: 1;
    display: flex;
    justify-content: center;
    ${media.mobileDevice` 
    height: ${({ height }) => (height ? height : '30px')};
    justify-content:flex-start;
    font-size:14px;
`};
`;
export const ItemsNotAllowedText = styled.div`
    font-size: 16px;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    color: ${({ color }) => (color ? color : '#130e4a')};
    font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '')};
    letter-spacing: -0.11px;
    opacity: 1;
    display: flex;
    justify-content: flex-start;
    margin: ${({ margin }) => (margin ? margin : '15px 0 15px 0')};
    height: ${({ height }) => (height ? height : '35px')};
    
    ${media.mobileDevice` 
    font-size:14px;
    margin:${({ margin }) => (margin ? margin : '15px 0 0 0')};
`};
`;

export const ItemsSubText = styled.div`
    height: ${({ webHeight }) => (webHeight ? webHeight : '55px')};
    font-size: 16px;
    font-family: 'AvenirNextWorld Regular';
    color: #000000;
    letter-spacing: -0.11px;
    opacity: 1;

    ${media.mobileDevice` 
    height:${({ height }) => (height ? height : '55px')};
    margin-bottom:15px;
   
`};
`;
export const ItemTitle = styled.div`
    flex-basis: ${({ flexBasis }) => (flexBasis ? flexBasis : '30%')};
    color: ${({ color }) => (color ? color : '#130e4a')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '')};
    ${media.mobileDevice`
    flex-basis:${({ mbFlexBasis }) => (mbFlexBasis ? mbFlexBasis : '40%')};     
         `}
`;
export const Description = styled.div`
    flex-basis: ${({ flexBasis }) => (flexBasis ? flexBasis : '70%')};
    ${media.mobileDevice`
    flex-basis:60%;       
         `}
`;

export const ExclusionItemsNotAllowedDiv = styled.div`
    width: ${({ width }) => (width ? width : '700px')};
    max-height: 550px;
    overflow-y: visible;
    height: ${({ height }) => (height ? height : '205px')};
    ${media.mediumDevice`
    width: ${({ width }) => (width ? width : '650px')};
    max-height:100%;          
    `};
    ${media.mobileDevice`
         width:310px ;
         max-height:520px;
         overflow-y: ${({ hideScroll }) => (hideScroll ? 'hidden' : 'scroll')}; 
         height: ${({ mbHeight }) =>
             mbHeight ? mbHeight : '300px'};              
        `};
`;

export const ButtonFooter = styled.div`
    display: flex;
    flex-direction: ${({ showCancelButton }) =>
        showCancelButton ? 'row' : ''};
    justify-content: ${({ center, showCancelButton }) =>
        showCancelButton && center ? 'center' : 'flex-end'};
    margin-top: ${({ marginTop }) => (marginTop ? marginTop : '')};
    position: static;
    bottom: 0;
    ${media.mobileDevice` 
        position:   ${({ mbPosition }) =>
            mbPosition ? mbPosition : 'relative'};
        margin-top:16px;
    `};
`;

export const ButtonFooterWrapper = styled.div`
    background-color: #ffffff;
    width: 100%;
    padding: 5px;
    display: flex;
    justify-content: flex-end;
    ${media.mobileDevice` 
        padding: 5px;
    `};
`;
export const NoInventoryShippingDiv = styled.div`
    width: 430px;
    height: ${({ height }) => (height ? height : '140px')};
    ${media.mobileDevice`
         width:${({ mobileWidth }) => (mobileWidth ? mobileWidth : '310px')};
         height:100%;
                           
         `}
`;
export const ShippingText = styled(Text)`
    font: 15px Avenir Next World;
    font-family: 'AvenirNextWorld Regular';
    color: #000000;
    width: 400px;
    height: ${({ height }) => (height ? height : '90px')};
    line-height: 20px;
    ${media.mobileDevice`
    font:'14px';
    font-family:'AvenirNextWorld Regular';
    width:${({ mobileWidth }) => (mobileWidth ? mobileWidth : '290px')};
    height: ${({ mobileHeight }) => (mobileHeight ? mobileHeight : '100px')};
         `}
`;

export const EmptyCart = styled.div`
    display: flex;
    flex-direction: column;
    width: 430px;
    height: ${({ height }) => (height ? height : '165px')};
    ${media.mobileDevice`
         width:100%;
                           
         `}
`;

export const WarningMessage = styled.p`
    font: 18px Avenir Next World;
    font-family: 'AvenirNextWorld Regular';
    color: #000000;
    margin: 12px 0 0 0;
`;
export const AlertImageContainer = styled.div`
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
`;

export const AlertImage = styled.img`
    width: 18%;
    ${media.mobileDevice`
        width: 25%;
    `};
`;
export const MessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
`;

export const ProductsContainer = styled.div`
    ${scrollBarStyle}
    overflow: scroll;
    max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : '142px')};
    ${media.mobileDevice`
    margin-top: ${({ isProductTemplateExclusionItems }) =>
        isProductTemplateExclusionItems ? '14px' : 'unset'};
    max-height: ${({ isProductTemplateExclusionItems }) =>
        isProductTemplateExclusionItems ? '142px' : '70px'};
`};
`;
